/**
 * <Address />
 *
 * NOTE: we're using address data inside data/address.js instead of having 
 * a detached address file for this form. 
 *
 * @parent anybody
 * @stateful
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import parseJson from '../../parseJson';
import { CountryDropdown, RegionDropdown } from "vendor/react-country-region-selector"
import './Address.scss';

export function address(props) {
  const {
    schema,
    onChange,
    options,
    placeholder,
  } = props;

  const {
    name,
  } = schema;

  const {
    maxlength,
  } = options;
  
  let value = parseJson(props.value || {});

  return (
    <Address 
      name={name}
      value={value}
      onChange={(data)=>{ props.onChange(JSON.stringify(data)); }}
      {...options}
    />
  );
}

class Address extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(itemName, itemValue) {
    const {
      value,
      onChange,
    } = this.props;

    onChange({
      ...value,
      [itemName]: itemValue,
    }, itemName);
  }

  render() {
    const {
      name,
      value,
      placeholderAsLabel,
    } = this.props;

    let placeholders = {};
    if (placeholderAsLabel) {
      placeholders = {
        'country': __('Country', 'address'), 
        'unit': __('Unit No.', 'address'), 
        'street': __('Street', 'address'), 
        'postalCode': __('Postal Code', 'address'), 
        'province': __('Province/States', 'address'), 
        'city': __('City', 'address'), 
      }
    }

    return (
      <div className='address-wrapper form-input'>

        <div className='outline-form-field street-unit-number'>
          <div className='street'>
          { placeholderAsLabel !== true && <label>{__('Street', 'address')}</label> }
            <input 
              type='text' className='form-control'
              value={value.street}
              placeholder={placeholders.street}
              onChange={(e)=>{ this.onChange('street', e.target.value) }}
            />
          </div>
          <div className='unit-number'>
           { placeholderAsLabel !== true && <label>{__('Unit No.', 'address')}</label> }
            <input 
              placeholder={placeholders.unit}
              type='text' className='form-control' 
              value={value.unit}
              onChange={(e)=>{ this.onChange('unit', e.target.value) }}
            />
          </div>
        </div>
        <div className='outline-form-field'>
          { placeholderAsLabel !== true && <label>{__('City', 'address')}</label> }
          <input 
            placeholder={placeholders.city}
            type='text' className='form-control' 
            value={value.city}
            onChange={(e)=>{ this.onChange('city', e.target.value) }}
          />
        </div>
        <div className='outline-form-field'>
          { placeholderAsLabel !== true && <label>{__('Country', 'address')}</label> }
          <CountryDropdown
            defaultOptionLabel={__('Country', 'address')}
            value={value.country}
            placeholder={placeholders.country}
            classes='form-control'
            onChange={(data)=>{ this.onChange('country', data) }}
          />
        </div>
        { value.country && 
          <div className='outline-form-field'>
            { placeholderAsLabel !== true && <label>{__('Province/States', 'address')}</label> }
            <RegionDropdown
              defaultOptionLabel={__('Province/States', 'address')}
              country={value.country}
              value={value.province}
              classes='form-control'
              onChange={(data)=>{ this.onChange('province', data) }}
            />
          </div>
        }
        <div className='outline-form-field'>
          { placeholderAsLabel !== true && <label>{__('Postal Code', 'address')}</label> }
          <input 
            type='text' className='form-control' 
            placeholder={placeholders.postalCode}
            value={value.postalCode}
            onChange={(e)=>{ this.onChange('postalCode', e.target.value) }}
          />
        </div>
      </div>
    ) 
  }
}

export default Address;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/Address/index.js